import { render, staticRenderFns } from "./TotalClosureDayGrid.vue?vue&type=template&id=22c5979c"
import script from "./TotalClosureDayGrid.js?vue&type=script&lang=js&external"
export * from "./TotalClosureDayGrid.js?vue&type=script&lang=js&external"
import style0 from "./TotalClosureDayGrid.vue?vue&type=style&index=0&id=22c5979c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports